import React, { useMemo, useEffect, useRef, useCallback, useState } from 'react'
import { gsap } from 'gsap'

//* Style
import RunningTextStyle from './style'

// Components
import Icon from 'components/common/Icon'
import Text from 'components/common/Text'
import AnimationWrap from 'components/common/AnimationWrap'

//* Hoc's
import { withUIContext } from 'context'

//* Gsap functions
import { slideDown } from 'helpers/_gsapFunctions'
import { Coin, Diamond } from 'svg'

const RunningText = ({ youtubeLink, winWidth }) => {
	//! States
	const [secObj, setSecObj] = useState()

	//! Refs
	const items = useRef([])
	const textRef0 = useRef()
	const textRef1 = useRef()
	const firstItemRef = useRef()
	const secondItemRef = useRef()

	const tl0 = useMemo(() => new gsap.timeline({ repeat: -1, paused: true }), [])
	const tl1 = useMemo(() => new gsap.timeline({ repeat: -1, paused: true }), [])

	useEffect(() => {
		tl1.progress(0).clear()
		tl0.progress(0).clear()

		tl0.to(textRef0.current, 14, {
			x: '-50%',
			ease: 'none',
		})

		tl1.set(textRef1.current, {
			x: '-50%',
			ease: 'none',
		}).to(textRef1.current, 14, {
			x: '0%',
			ease: 'none',
		})

		tl0.play()
		tl1.play()
	}, [])

	const fastSpeed = useMemo(() => 15, [])
	const slowSpeed = useMemo(() => 50, [])

	const toggleHover = useCallback(
		(startDuration) => {
			tl0.duration(startDuration)
			tl1.duration(startDuration)
		},
		[textRef0, textRef1]
	)

	const startAnimeArr = useCallback((x) => {
		if (x) {
			//! slideDown(item, stagger, delay)
			slideDown([firstItemRef.current, secondItemRef.current], 0.2)
		}
	}, [])

	useEffect(() => {
		if (items?.current) {
			setSecObj([items.current])
		}
	}, [items, winWidth])

	const storeText = () => {
		return (
			<a ref={firstItemRef} className='FlexBox alignMiddle line' href={youtubeLink} target='_blank'>
				<Text tag={'h2'} className={'h1 terminaBold'} text={'subscribeToMe'} />
				<Coin className='icon-coin' />
				<Text tag={'h2'} className={'h1 terminaBold'} text={'youtubeChannel'} />
				<Diamond className='icon-diamond' />
				<Text tag={'h2'} className={'h1 terminaBold'} text={'subscribeToMe'} />
				<Coin className='icon-coin' />
				<Text tag={'h2'} className={'h1 terminaBold'} text={'youtubeChannel'} />
				<Diamond className='icon-diamond' />
			</a>
		)
	}

	const storeTextSecond = () => {
		return (
			<a ref={secondItemRef} className='FlexBox alignMiddle line' href={youtubeLink} target='_blank'>
				<Text tag={'h2'} className={'h1 terminaBold'} text={'subscribeToMe'} />
				<Icon className='icon-like' />
				<Text tag={'h2'} className={'h1 terminaBold'} text={'youtubeChannel'} />
				<svg className='icon-youtube' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 118.95 97.79'>
					<g id='Layer_2' data-name='Layer 2'>
						<g id='Layer_1-2' data-name='Layer 1'>
							<path d='M114.61,37.87c-.82-2.56-1.66-5.22-2.36-7.86-.37-1.35-.71-2.76-1.07-4.2-2.33-9.45-5-20.15-13.67-24.2C92.14-.88,85.14.05,79,.87a1.5,1.5,0,0,0,.39,3c5.78-.77,12.32-1.64,16.89.49,7.4,3.43,9.86,13.4,12,22.19.36,1.46.71,2.89,1.08,4.25.72,2.71,1.57,5.4,2.4,8,2.26,7.16,4.4,13.92,4.19,21.17-.12,3.89-.25,8.3-2.26,11.76-3,5.14-14.63,8.57-19.61,10A422.25,422.25,0,0,1,39.16,94c-7.58,1.16-15.31,1.65-20.54-2.62a17.17,17.17,0,0,1-5.68-8.09A290.29,290.29,0,0,1,4.86,49.1c-.49-2.59-1-5.33-1.6-8.3-1.35-6.83,3-14.15,7.89-18.38A31.63,31.63,0,0,1,21.5,17C38.3,11.25,66.4,6.4,71,5.71a1.44,1.44,0,0,0,.46,0,1.67,1.67,0,0,0,1.51-1.14,1.49,1.49,0,0,0-.4-1.5c-.62-.59-.62-.59-6.62.45C63,4,58.44,4.83,52.86,6c-9.36,1.9-22.57,4.87-32.34,8.23a34,34,0,0,0-11.32,6C4.05,24.59-1.37,32.81.31,41.38c.59,3,1.11,5.7,1.6,8.29a297.34,297.34,0,0,0,8.17,34.5,20.13,20.13,0,0,0,6.66,9.52c3.8,3.11,8.52,4.1,13.53,4.1A62.33,62.33,0,0,0,39.61,97,426.76,426.76,0,0,0,94.92,84.62c5.77-1.7,17.78-5.23,21.36-11.4,2.39-4.13,2.54-9.15,2.66-13.18C119.17,52.28,116.85,45,114.61,37.87Z' />
							<path d='M46.07,35.15a1.86,1.86,0,0,0-.56,1.71l5.1,27a1.94,1.94,0,0,0,1.11,1.42,2,2,0,0,0,1.8-.07L77.39,51.65a6.31,6.31,0,0,0,3.2-3.2,3.9,3.9,0,0,0-.28-3.2C79,42.8,75.54,41.76,74.52,41.5l-26.7-6.8A1.88,1.88,0,0,0,46.07,35.15Zm27.71,9.26c1.82.46,3.42,1.39,3.89,2.27a.93.93,0,0,1,.08.81c-.2.59-1,1.09-1.84,1.55L53.29,61.88,48.79,38Z' />
						</g>
					</g>
				</svg>
				<Text tag={'h2'} className={'h1 terminaBold'} text={'subscribeToMe'} />
				<Icon className='icon-like' />
				<Text tag={'h2'} className={'h1 terminaBold'} text={'youtubeChannel'} />
				<svg className='icon-youtube' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 118.95 97.79'>
					<g id='Layer_2' data-name='Layer 2'>
						<g id='Layer_1-2' data-name='Layer 1'>
							<path d='M114.61,37.87c-.82-2.56-1.66-5.22-2.36-7.86-.37-1.35-.71-2.76-1.07-4.2-2.33-9.45-5-20.15-13.67-24.2C92.14-.88,85.14.05,79,.87a1.5,1.5,0,0,0,.39,3c5.78-.77,12.32-1.64,16.89.49,7.4,3.43,9.86,13.4,12,22.19.36,1.46.71,2.89,1.08,4.25.72,2.71,1.57,5.4,2.4,8,2.26,7.16,4.4,13.92,4.19,21.17-.12,3.89-.25,8.3-2.26,11.76-3,5.14-14.63,8.57-19.61,10A422.25,422.25,0,0,1,39.16,94c-7.58,1.16-15.31,1.65-20.54-2.62a17.17,17.17,0,0,1-5.68-8.09A290.29,290.29,0,0,1,4.86,49.1c-.49-2.59-1-5.33-1.6-8.3-1.35-6.83,3-14.15,7.89-18.38A31.63,31.63,0,0,1,21.5,17C38.3,11.25,66.4,6.4,71,5.71a1.44,1.44,0,0,0,.46,0,1.67,1.67,0,0,0,1.51-1.14,1.49,1.49,0,0,0-.4-1.5c-.62-.59-.62-.59-6.62.45C63,4,58.44,4.83,52.86,6c-9.36,1.9-22.57,4.87-32.34,8.23a34,34,0,0,0-11.32,6C4.05,24.59-1.37,32.81.31,41.38c.59,3,1.11,5.7,1.6,8.29a297.34,297.34,0,0,0,8.17,34.5,20.13,20.13,0,0,0,6.66,9.52c3.8,3.11,8.52,4.1,13.53,4.1A62.33,62.33,0,0,0,39.61,97,426.76,426.76,0,0,0,94.92,84.62c5.77-1.7,17.78-5.23,21.36-11.4,2.39-4.13,2.54-9.15,2.66-13.18C119.17,52.28,116.85,45,114.61,37.87Z' />
							<path d='M46.07,35.15a1.86,1.86,0,0,0-.56,1.71l5.1,27a1.94,1.94,0,0,0,1.11,1.42,2,2,0,0,0,1.8-.07L77.39,51.65a6.31,6.31,0,0,0,3.2-3.2,3.9,3.9,0,0,0-.28-3.2C79,42.8,75.54,41.76,74.52,41.5l-26.7-6.8A1.88,1.88,0,0,0,46.07,35.15Zm27.71,9.26c1.82.46,3.42,1.39,3.89,2.27a.93.93,0,0,1,.08.81c-.2.59-1,1.09-1.84,1.55L53.29,61.88,48.79,38Z' />
						</g>
					</g>
				</svg>
			</a>
		)
	}

	return (
		<RunningTextStyle ref={items}>
			<AnimationWrap state={secObj} startAnimeArr={startAnimeArr}>
				<div className='container overflowHidden'>
					<div
						className='relativeWrap scrollingWrap'
						ref={textRef0}
						onMouseEnter={() => toggleHover(slowSpeed)}
						onMouseLeave={() => toggleHover(winWidth < 1024 ? slowSpeed : fastSpeed)}
					>
						<div className='FlexBox overflowHidden'>{storeText()}</div>
					</div>
				</div>
				<div className='container overflowHidden secondLine'>
					<div
						className='relativeWrap scrollingWrap'
						ref={textRef1}
						onMouseEnter={() => toggleHover(slowSpeed)}
						onMouseLeave={() => toggleHover(winWidth < 1024 ? slowSpeed : fastSpeed)}
					>
						<div className='FlexBox  overflowHidden'>{storeTextSecond()}</div>
					</div>
				</div>
			</AnimationWrap>
		</RunningTextStyle>
	)
}

export default withUIContext(RunningText, ['winWidth'])
